import React from "react";
import SessionSummary from "../sessions/SessionSummary";
import { Link } from "react-router-dom";

const EnrolledSessions = ({ enrollments }) => {
  if (enrollments) {
    return (
      <div className="project-list section">
        <div className="row">
          {enrollments &&
            enrollments.map((session) => {
              return (
                <Link to={"/enrolledsession/" + session.id} key={session.id}>
                  <SessionSummary session={session} />
                </Link>
              );
            })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="container center">
        <p>Loading details...</p>
      </div>
    );
  }
};

export default EnrolledSessions;
